// src/api/queries/kbs.js
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const KBS_KEY = ["kbs"];

export function useKbsQuery(options = {}) {
  return useQuery({
    queryKey: KBS_KEY,
    queryFn: () => api.get("/kbs"),
    staleTime: 30 * 1000,
    ...options,
  });
}

export function useUpsertKbMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }) =>
      api.post("/kbs", { ...body, id }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KBS_KEY }),
  });
}

export function useDeleteKbMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/kbs/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KBS_KEY }),
  });
}
